import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
const couponData: Record<string, {
  code: string;
  discountType: string;
  usageType: string;
  group: string;
  discountAmount: string;
  uses: string;
  expireDate: string;
  limitations: string;
  exceedAmount: string;
  created: string;
}> = {
  '2006': {
    code: '2006',
    discountType: 'dollar',
    usageType: 'per_customer',
    group: '',
    discountAmount: '19.95',
    uses: '',
    expireDate: '10/03/2020',
    limitations: 'single',
    exceedAmount: 'no',
    created: '01/01/2020'
  },
  '2007': {
    code: '2007',
    discountType: 'dollar',
    usageType: 'per_customer',
    group: '',
    discountAmount: '19.95',
    uses: '',
    expireDate: '09/18/2020',
    limitations: 'single',
    exceedAmount: 'no',
    created: '01/01/2020'
  }
};
const defaultCoupon = {
  code: 'AN270',
  discountType: 'percentage',
  usageType: 'unlimited_by_customer',
  group: 'PAR',
  discountAmount: '100.00',
  uses: '',
  expireDate: 'Not set',
  limitations: 'all',
  exceedAmount: 'no',
  created: '05/18/2021'
};
export function ViewCoupon() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const coupon = id && couponData[id] ? couponData[id] : defaultCoupon;
  const rows = [{
    label: 'Coupon Code',
    value: coupon.code
  }, {
    label: 'Discount Type',
    value: coupon.discountType
  }, {
    label: 'Usage Type',
    value: coupon.usageType
  }, {
    label: 'Group',
    value: coupon.group
  }, {
    label: 'Discount Amount',
    value: coupon.discountAmount
  }, {
    label: 'Uses',
    value: coupon.uses
  }, {
    label: 'Expire Date',
    value: coupon.expireDate
  }, {
    label: 'Limitations',
    value: coupon.limitations
  }, {
    label: 'Exceed Amount',
    value: coupon.exceedAmount
  }, {
    label: 'Created',
    value: coupon.created
  }];
  return <div className="space-y-4" data-id="element-2350">
      <div className="flex items-center justify-between" data-id="element-2351">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2352">View Coupon</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/coupons')} data-id="element-2353">
          ← Back to Coupons
        </Button>
      </div>

      <Card data-id="element-2354">
        <CardContent className="pt-6" data-id="element-2355">
          <h2 className="text-base font-semibold text-slate-800 mb-3" data-id="element-2356">
            Coupon
          </h2>
          <table className="text-sm w-full max-w-lg" data-id="element-2357">
            <tbody data-id="element-2358">
              {rows.map(({
              label,
              value
            }) => <tr key={label} className="border-b border-slate-100" data-id="element-2359">
                  <td className="py-2 pr-6 font-medium text-slate-700 w-36 align-top" data-id="element-2360">
                    {label}
                  </td>
                  <td className="py-2 text-slate-900" data-id="element-2361">{value}</td>
                </tr>)}
            </tbody>
          </table>

          <div className="mt-6 flex gap-3" data-id="element-2362">
            <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate(`/coupons/edit/${id}`)} data-id="element-2363">
              Edit Coupon
            </Button>
            <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/coupons')} data-id="element-2364">
              Back to List
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}